import { useEffect } from 'react';
import { useThree } from '@react-three/fiber';
import { Vector3 } from 'three';
import { useClickStore } from '../../store/clickStore';
import { useSectionStore } from '../../store/sectionStore';

export function planCameraPose(camera, controls) {
  const target = controls?.target ? controls.target.clone() : new Vector3();
  const dist =
    camera?.position && controls?.target
      ? Math.max(80, camera.position.distanceTo(controls.target))
      : 800;
  return {
    position: new Vector3(target.x, target.y + dist, target.z),
    target,
    up: new Vector3(0, 0, -1),
  };
}

export default function PlanLookRig({ controlRef }) {
  const camera = useThree((s) => s.camera);
  const invalidate = useThree((s) => s.invalidate);
  const planLocked = useClickStore((s) => s.planLocked);

  useEffect(() => {
    const controls = controlRef?.current;
    if (!controls) return undefined;
    const prevRotate = controls.enableRotate;
    if (planLocked) {
      useClickStore.getState().setFlyAround(false);
      useSectionStore.getState().setLookLocked(false);
      controls.enableRotate = false;
      const pose = planCameraPose(camera, controls);
      camera.up.copy(pose.up);
      camera.position.copy(pose.position);
      controls.target.copy(pose.target);
      camera.lookAt(pose.target);
      controls.update();
      invalidate();
    }
    return () => {
      controls.enableRotate = prevRotate;
      if (!useSectionStore.getState().lookLocked) {
        camera.up.set(0, 1, 0);
      }
    };
  }, [planLocked, camera, controlRef, invalidate]);

  return null;
}
